import { createSlice } from "@reduxjs/toolkit";
import {
  fetchFreelancerProjectDetails,
  fetchMyProjects,
  fetchProjectDetails,
  fetchProjectDliveableFreelancerDetails,
  manageInvitation,
  markAsStartProject,
  uploadDeliverableData,
} from "../actions/projectAction";

const initialState = {
  isLoading: false,
  isViewProjectDetails: false,
  projectList: {},
  projectData: {},
  deliveableList: []
};

const projectSlice = createSlice({
  name: "find-a-job-projects",
  initialState,
  reducers: {
    setIsViewProjectDetails: (state, action) => {
      state.isViewProjectDetails = action.payload;
    },

  },
  extraReducers: (builder) => {
    // fetch-my-projects
    builder.addCase(fetchMyProjects.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchMyProjects.fulfilled, (state, action) => {
      console.log({ action })
      const { data } = action?.payload || {};
      state.isLoading = false;

      const grouped = Object.groupBy(data?.projects || [], (p) => {
        if (p?.invite_status === "accepted") {
          return "todo";
        };
        if (p?.invite_status === "on_going") {
          return "ongoing";
        };
        if (p?.invite_status === "invited") {
          return "inreview";
        };
        if (p?.invite_status === "rejected") {
          return "rejected";
        };
        return p?.invite_status || "others";
      });
      state.projectList = {
        all: data?.projects || [],
        ...grouped,
      };

    });
    builder.addCase(fetchMyProjects.rejected, (state, action) => {
      state.isLoading = false;
    });
    // fetch-project-details
    builder.addCase(fetchProjectDetails.pending, (state, action) => {

      state.isLoading = true;
    });
    builder.addCase(fetchProjectDetails.fulfilled, (state, action) => {
      const { data } = action.payload;
      state.projectData = {...data, ...state.projectData} || {};
      state.isViewProjectDetails = true;
      state.isLoading = false;
    });
    builder.addCase(fetchProjectDetails.rejected, (state, action) => {

      state.isLoading = false;
    });

    // fetchFreelancerProjectDetails
    builder.addCase(fetchFreelancerProjectDetails.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchFreelancerProjectDetails.fulfilled, (state, action) => {
      const { data } = action.payload;
      state.projectData = {...data, ...state.projectData} || {};
      state.isViewProjectDetails = true;
      state.isLoading = false;
    });
    builder.addCase(fetchFreelancerProjectDetails.rejected, (state, action) => {

      state.isLoading = false;
    });


    // manage-invitation
    builder.addCase(manageInvitation.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(manageInvitation.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(manageInvitation.rejected, (state, action) => {
      state.isLoading = false;
    });

    // markAsStartProject
    builder.addCase(markAsStartProject.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(markAsStartProject.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(markAsStartProject.rejected, (state, action) => {
      state.isLoading = false;
    });

    // uploadDeliverableData
    builder.addCase(uploadDeliverableData.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(uploadDeliverableData.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(uploadDeliverableData.rejected, (state, action) => {
      state.isLoading = false;
    });

    // fetchProjectDliveableFreelancerDetails
    builder.addCase(fetchProjectDliveableFreelancerDetails.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchProjectDliveableFreelancerDetails.fulfilled, (state, action) => {
      const { data } = action.payload;
      state.deliveableList = data?.deliverables || [];
      state.isLoading = false;
    });
    builder.addCase(fetchProjectDliveableFreelancerDetails.rejected, (state, action) => {
      state.isLoading = false;
    });
  },
});

export default projectSlice.reducer;
export const { setIsViewProjectDetails } = projectSlice.actions;
